export const translations = {
  es: {
    menu: {
      home: 'Inicio',
      pricing: 'Precios',
      about: 'Nosotros',
      training: 'Formación',
      dashboard: 'Dashboard',
      successPath: 'Ruta al Éxito',
      profile: 'Mi Perfil',
      admin: 'Admin'
    },
    auth: {
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      logout: 'Cerrar sesión'
    },
    employer: {
      portal: 'Portal Empresas',
      access: 'Acceso Empresas',
      userPortal: 'Portal Usuarios'
    }
  },
  en: {
    menu: {
      home: 'Home',
      pricing: 'Pricing',
      about: 'About',
      training: 'Training',
      dashboard: 'Dashboard',
      successPath: 'Path to Success',
      profile: 'My Profile',
      admin: 'Admin'
    },
    auth: {
      login: 'Log In',
      register: 'Sign Up',
      logout: 'Log Out'
    },
    employer: {
      portal: 'Employer Portal',
      access: 'Employer Access',
      userPortal: 'User Portal'
    }
  }
};